import { FC } from 'react';
import { DeepMap, FieldError, UseFormRegister } from 'react-hook-form';

import Input from '@/components/form-elements/input';
import getVariablePlainText from '@/lib/get-variable-plain-text';
import useVariables from '@/lib/hooks/use-variables';
import { LotteryFormData } from '@/lib/lottery2';

import { Field } from '..';

interface SelectProps {
  register: UseFormRegister<LotteryFormData>;
  field: Field;
  errors: DeepMap<LotteryFormData, FieldError>;
}

const LotteryInput: FC<SelectProps> = ({ register, field, errors }) => {
  const { name, label, type, placeholder, required, pattern } = field;
  const variables = useVariables();
  const incorrectPatternText =
    getVariablePlainText(variables['lottery-form-incorrect-pattern-text']) ||
    'Incorrect pattern. Must be:';

  return (
    <Input
      {...register(name, {
        required,
        ...(pattern ? { pattern } : {}),
      })}
      id={name}
      label={label as string}
      type={type}
      placeholder={placeholder}
      containerClassName="md:mr-4 flex flex-col"
      error={
        errors?.[name]?.type === 'pattern'
          ? `${incorrectPatternText} ${placeholder}`
          : errors?.[name]?.message
      }
      showLabel
    />
  );
};

export default LotteryInput;
